module.exports = __webpack_public_path__ + "img/QA_pin02.f766a08c.svg";